import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"

const tagsListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, tag) => <>{tag.id}</>,
    },
    {
      text: "Tag name",
      dataField: "tag",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, tag) => <>{tag.tag}</>,
    },
    {
      text: "Created On",
      dataField: "created_at",
      formatter: (cellContent, tag) => (
        <div className={"font-size-12"}>{getFormattedTime(tag.created_at)}</div>
      ),
    },
    {
      text: "# of Experiences",
      dataField: "events_count",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, tag) => <>{tag.events_count || "0"}</>,
    },
    {
      text: "# of Users",
      dataField: "users_count",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, tag) => <>{tag.users_count || "0"}</>,
    },
    {
      text: "# of Communications",
      dataField: "comm_count",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, tag) => <>{tag.comm_count || "0"}</>,
    },
  ]
}

export default tagsListColumns
